import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, ListItem, ListItemText, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../../../hooks/store-hooks"
import { useListaCEPService } from "../../../../../../../../../use-cases/geo-veles"
import { FixedSizeList, ListChildComponentProps } from "react-window"
import { formatCep } from "../../../../../../../../../utils"
import AutoSizer from "react-virtualized-auto-sizer"
// Icons
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd'
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove'
import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import { theme } from "../../../../../../../../styles"

function RenderActualCeps(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCEP } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 !== 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCep(listaCEP.editListaCEPForm.fields.ceps[index] ?? '')} />
        </ListItem>
    );
}

function RenderNewCeps(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCEP } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 === 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCep(listaCEP.fileListData.fileListTableValues.fileListValidData[index] ?? '')} />
        </ListItem>
    );
}

function RenderRepeatedCeps(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCEP } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 !== 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCep(listaCEP.fileListData.fileListTableValues.fileListRepeatedData[index] ?? '')} />
        </ListItem>
    );
}

function RenderInvalidCeps(props: ListChildComponentProps) {
    const { index, style } = props;
    const { listaCEP } = useAppSelector((state) => state)

    return (
        <ListItem
            style={style}
            key={index}
            sx={{
                textAlign: 'center',
                background: (props.index % 2 === 0) ? '#f6f6f6' : ''
            }}
        >
            <ListItemText primary={formatCep(listaCEP.fileListData.fileListTableValues.fileListInvalidData[index] ?? '')} />
        </ListItem>
    );
}

export const PreviewListaCEP = (props: {
    openPreviewListaCEP: boolean
}) => {
    // State
    const { listaCEP } = useAppSelector((state) => state)
    // Hook
    const { openPreviewListaCEP, addFileListToListaCEP, openImportFileListaCEP } = useListaCEPService()

    return (
        <>
            {
                props.openPreviewListaCEP === true &&
                <>
                    <Dialog
                        fullWidth
                        maxWidth={'lg'}
                        open={listaCEP.openPreviewListaCEP}
                        onClose={() => {
                            openPreviewListaCEP(false)
                        }}
                    >
                        <DialogTitle>
                            <Typography fontWeight={'bold'} textTransform="uppercase" variant="h5" color='primary'>
                                Pré visualização do arquivo - <strong>{listaCEP.fileData.name}</strong>
                            </Typography>
                        </DialogTitle>
                        <Box px={2}>
                            <Divider color={theme.palette.primary.main}/>
                        </Box>
                        <DialogContent>
                            <Grid container
                                height={300}
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    flexDirection: 'row',
                                    overflowY: 'hidden'
                                }}
                            >
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistAddCheckIcon sx={{ width: '8%', height: '8%' }} /> CEPs atuais:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCEP.editListaCEPForm.fields.ceps.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderActualCeps}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistAddIcon sx={{ width: '8%', height: '8%' }} /> CEPs novos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCEP.fileListData.fileListTableValues.fileListValidData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderNewCeps}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <SyncProblemIcon sx={{ width: '8%', height: '8%' }} /> CEPs repetidos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCEP.fileListData.fileListTableValues.fileListRepeatedData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderRepeatedCeps}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Typography color="primary" variant="h6" align={'center'} fontWeight={'bold'}>
                                        <PlaylistRemoveIcon sx={{ width: '8%', height: '8%' }} /> CEPs inválidos:
                                    </Typography>
                                    <AutoSizer >
                                        {(data: any) => (
                                            <FixedSizeList
                                                height={data.height}
                                                width={data.width}
                                                itemSize={46}
                                                itemCount={listaCEP.fileListData.fileListTableValues.fileListInvalidData.length ?? 0}
                                                overscanCount={5}
                                                style={{
                                                    marginTop: 3.5
                                                }}
                                            >
                                                {RenderInvalidCeps}
                                            </FixedSizeList>
                                        )}
                                    </AutoSizer>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Box px={2}>
                            <Divider color={theme.palette.primary.main}/>
                        </Box>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    openPreviewListaCEP(false)
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    addFileListToListaCEP()
                                    openPreviewListaCEP(false)
                                    openImportFileListaCEP(false)
                                }}
                            >
                                Enviar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
        </>
    )
}